<template>
    <div id="team-summary-chat" v-if="!!selectedChat">
        <div class="head">
            <template>
                <a-dropdown :trigger="['click']">
                    <a class="ant-dropdown-link" @click.prevent>
                        <label class="imgUpload">
                            <a-avatar
                                id="team-summery-avatar"
                                v-if="
                                    groupProfilePicture || $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')
                                "
                                :src="
                                    groupProfilePicture || $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')
                                "
                                :size="84"
                            />

                            <div id="team-chat-container" v-else>
                                <TeamChatIcon id="team-chat-icon" />
                            </div>
                        </label>
                    </a>
                    <template #overlay>
                        <a-menu id="dropdown-menu">
                            <a-menu-item class="menu-item" key="0">
                                <input
                                    id="change-pp"
                                    class="change-pp-class"
                                    type="file"
                                    @change="uploadFile"
                                    accept="image/png, image/jpeg, image/gif"
                                />
                                <label
                                    for="change-pp"
                                    v-if="
                                        groupProfilePicture ||
                                        $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')
                                    "
                                    ><a>{{ $t("message.changePhoto") }}</a></label
                                >
                                <label for="change-pp" v-else
                                    ><a>{{ $t("message.addPhoto") }}</a></label
                                >
                            </a-menu-item>

                            <a-menu-item
                                class="menu-item"
                                key="1"
                                v-if="
                                    groupProfilePicture || $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')
                                "
                            >
                                <a @click="showViewer">{{ $t("message.seePhoto") }}</a>
                            </a-menu-item>
                            <a-menu-divider
                                v-if="
                                    groupProfilePicture || $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')
                                "
                            />
                            <a-menu-item
                                v-if="
                                    groupProfilePicture || $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')
                                "
                                id="delete-option"
                                class="menu-item"
                                key="2"
                                @click="deleteProfilePhoto"
                                >{{ $t("message.deletePhoto") }}
                            </a-menu-item>
                        </a-menu>
                    </template>
                </a-dropdown>
            </template>
            <a-modal id="groupViewerModal" :visible="isImageViewerShow" :footer="false" @cancel="closeViewer">
                <img :src="groupProfilePicture || $_.get(selectedChat, 'meta.groupThread.groupProfilePicture')" />
            </a-modal>
        </div>
        <div class="user-name">{{ "TEAM" }}</div>
        <MediaSlide
            v-if="mediaSlideVisible"
            @close-media-slide="mediaSlideVisible = false"
            class="team-chat-media-area"
        />
        <div class="user-info" v-else>
            <div class="media-row" @click="mediaSlideVisible = true">
                <span class="media-text"> {{ $t("message.sumChat_MediaFile") }}</span>
                <span class="material-icons media-btn">arrow_forward</span>
            </div>
            <div class="user-info-head">{{ $t("message.userInformations") }}</div>
            <div v-if="onlineUserList.length > 0" class="user-list">
                <p id="online-users-label" v-if="offlineUserList.length > 0">{{ $t("message.online") }}</p>
                <div v-for="user in onlineUserList" style="margin-top: 10px">
                    <div class="team-user-info">
                        <span
                            class="team-user-item"
                            @click="
                                (e) => {
                                    e.preventDefault();
                                    user.userDetailVisible = !user.userDetailVisible;
                                }
                            "
                        >
                            <div class="avatarContainer team-agents-avatar">
                                <AgentAvatar :user-i-d="user._id" :size="30" :font-size="14" />
                            </div>
                            <div class="nameContainer">
                                <div class="tooltip-container" :title="user.name">
                                    {{ user.name }}
                                </div>
                            </div>
                        </span>
                        <span class="material-icons dm-message-btn" @click="directMessage(user)">message</span>
                    </div>
                    <div v-if="user.userDetailVisible">
                        <div class="agent-item-detail" v-for="data in datas">
                            <span class="material-icons" id="poped-icons">{{ data.icon }}</span>
                            <span class="poped_datas" :title="data.slot === 'email' ? user[data.slot] : null">
                                {{ user[data.slot] }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="offlineUserList.length > 0" class="user-list">
                <p id="offline-users-label" v-if="onlineUserList.length > 0">{{ $t("message.offline") }}</p>
                <div v-for="user in offlineUserList" style="margin-top: 10px">
                    <div class="team-user-info">
                        <span
                            class="team-user-item"
                            @click="
                                (e) => {
                                    e.preventDefault();
                                    user.userDetailVisible = !user.userDetailVisible;
                                }
                            "
                        >
                            <div class="avatarContainer team-agents-avatar">
                                <AgentAvatar :user-i-d="user._id" :size="30" :font-size="14" />
                            </div>
                            <div class="nameContainer">
                                <div class="tooltip-container" :title="user.name">
                                    {{ user.name }}
                                </div>
                            </div>
                        </span>
                        <span class="material-icons dm-message-btn" @click="directMessage(user)">message</span>
                    </div>
                    <div v-if="user.userDetailVisible">
                        <div class="agent-item-detail" v-for="data in datas">
                            <span class="material-icons" id="poped-icons">{{ data.icon }}</span>
                            <span class="poped_datas" :title="data.slot === 'email' ? user[data.slot] : null">
                                {{ user[data.slot] }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import CHAT_TYPES from "../../../utils/ChatTypes";
import MediaSlide from "./MediaSlide";
import * as _ from "lodash";
import axios from "axios";

const log = log2("TeamSummaryChat");
import Avatar from "vue-avatar";
import { sendSocketMessage } from "../../../utils/socketStream";
import { uploadAsset } from "../../../api/assetUpload";
import TeamChatIcon from "../../../components/svg/TeamChatIcon.vue";
import AgentAvatar from "../../../components/common/AgentAvatar.vue";

export default {
    name: "TeamSummaryChat",
    components: { Avatar, MediaSlide, TeamChatIcon, AgentAvatar },
    props: {},
    data() {
        return {
            datas: [
                {
                    name: "Email",
                    slot: "email",
                    icon: "email",
                },
                {
                    name: "Ülke, Dil",
                    slot: "lang",
                    icon: "language",
                },
                {
                    name: "Platform",
                    slot: "lastLoginPlatform",
                    icon: "room",
                },
            ],
            onlineUserList: [],
            offlineUserList: [],
            mediaSlideVisible: false,
            groupProfilePicture: null,
            isImageViewerShow: false,
        };
    },
    computed: {
        ...mapGetters({
            selectedChat: "team/selectedChat",
            chats: "team/chats",
            site: "site/site",
            user: "auth/user",
            groupThread: "team/groupThread",
        }),
        ...mapState({
            users: (state) => state.user.users.data,
            selectedChat: (state) => state.team.selectedChat,
            chats: (state) => state.team.chats,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            groupThread: (state) => state.team.groupThread.groupProfilePicture,
        }),
    },

    methods: {
        ...mapActions({
            selectedChatChange: "team/selectedChatChange",
            chatProfilePhotoUpdate: "team/chatProfilePhotoUpdate",
            chatProfilePhotoDelete: "team/chatProfilePhotoDelete",
        }),
        showViewer() {
            this.isImageViewerShow = true;
        },
        closeViewer() {
            this.isImageViewerShow = false;
        },
        directMessage(user) {
            const isDmChat = this.chats.filter((chat) => {
                if (chat.meta.chatType === CHAT_TYPES.THREAD) {
                    if (chat.meta.thread.agent1._id === user._id || chat.meta.thread.agent2._id === user._id) {
                        return chat;
                    }
                }
            });
            if (isDmChat.length > 0) {
                this.selectedChatChange(isDmChat[0]);
            } else {
                const thread = {
                    agent1: this.user._id,
                    agent2: user._id,
                };

                sendSocketMessage("team thread-chat-created", {
                    siteId: this.site._id,
                    thread,
                });
            }
        },
        uploadFile: async function (e) {
            const file = e.target.files[0];

            if (this.beforeUploadPicture(file)) {
                const path = `${this.site._id}/groupProfilePicture`;

                try {
                    const uploadData = await uploadAsset({ path, mime: file.type });

                    const newGroupProfilePicture = `https://static.supsis.live/${path + uploadData.data.asset._id}`;
                    this.$store.dispatch("team/groupProfilePicture", {
                        chatId: this.selectedChat._id,
                        groupProfilePicture: newGroupProfilePicture,
                    });

                    await axios({
                        method: uploadData.data.method,
                        url: uploadData.data.url,
                        data: file,
                        headers: { "Content-Type": "application/octet-stream" },
                    });

                    this.$toasted.success(this.$t("message.successImgUpload"), {
                        duration: 1000,
                        position: "bottom-center",
                    });

                    this.groupProfilePicture = newGroupProfilePicture;
                    this.chatProfilePhotoUpdate({
                        chatId: this.selectedChat._id,
                        groupProfilePicture: newGroupProfilePicture,
                    });
                } catch (e) {
                    this.$toasted.error(this.$t("message.errorImgUpload"), {
                        duration: 1000,
                        position: "bottom-center",
                    });
                }
            }
        },
        deleteProfilePhoto() {
            this.$dialog
                .confirm(this.$t("message.deletePhoto"), {
                    okText: this.$t("message.continue"),
                    cancelText: this.$t("message.cancel"),
                })
                .then(() => {
                    try {
                        this.$store.dispatch("team/groupProfilePicture", {
                            chatId: this.selectedChat._id,
                            groupProfilePicture: null,
                        });
                        this.$toasted.success(this.$t("message.successImgDelete"), {
                            duration: 1000,
                            position: "bottom-center",
                        });
                        this.groupProfilePicture = null;
                        this.chatProfilePhotoDelete({
                            chatId: this.selectedChat._id,
                            groupProfilePicture: null,
                        });
                    } catch (e) {
                        this.$toasted.error(this.$t("message.errorImgDelete"), {
                            duration: 1000,
                            position: "bottom-center",
                        });
                    }
                });
        },
        beforeUploadPicture(file) {
            const isJPG = file.type === "image/jpeg";
            const isPNG = file.type === "image/png";
            const isGIF = file.type === "image/gif";
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG && !isPNG && !isGIF) {
                this.$toasted.error(this.$t("message.errorImgUpload"), {
                    duration: 1000,
                    position: "bottom-center",
                });
                return false;
            }
            if (!isLt2M) {
                this.$toasted.error(this.$t("message.errorImgUpload"), {
                    duration: 1000,
                    position: "bottom-center",
                });
                return false;
            }
            return true;
        },
    },
    mounted() {
        this.users.filter((user) => {
            if (user.isOnline) {
                this.onlineUserList.push(user);
            } else {
                this.offlineUserList.push(user);
            }
        });
        this.onlineUserList = this.onlineUserList.map((user) => {
            return {
                ...user,
                userDetailVisible: false,
            };
        });
        this.offlineUserList = this.offlineUserList.map((user) => {
            return {
                ...user,
                userDetailVisible: false,
            };
        });
    },
};
</script>

<style lang="scss">
#team-summary-chat {
    max-height: 100% !important;

    .tooltip-container {
        width: 105px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .head {
        display: flex;
        justify-content: center;
        padding: 10px;
        align-items: end;

        .user-segment-avatar {
            height: 55px;
            width: 55px;
            display: flex;
            align-items: center;
            font-size: 16px;
            background: #c4c4c4;
            border-radius: 50%;
            margin: 5px;
        }

        .user-active {
            height: 10px;
            width: 10px;
            background: green;
            border-radius: 50%;
            margin-bottom: 10px;
            margin-left: -16px;
        }
    }

    .less-more {
        color: #ec4a1d;
        font-size: 20px;
        max-width: 22px;
        margin-right: 20px;
    }

    .user-name {
        font-size: initial;
        font-weight: 600;
        display: flex;
        justify-content: center;
    }

    .user-info {
        margin-top: 30px;
        margin-left: 20px;

        .media-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 15px;
            cursor: pointer;

            .media-text {
                font-size: 17px;
                font-weight: 600;
                color: #9f8524;
            }

            .media-btn {
                color: #9f8524;
                font-size: 17px;
                max-width: 22px;
                margin-right: 35px;
                font-weight: 600;
            }
        }

        .team-user-info {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;

            .team-user-item {
                display: flex;
                align-items: center;
                cursor: pointer;
                padding: 3px;
                border-radius: 7px;
                width: 75%;

                &:hover {
                    background: #ebebeb;
                }

                .avatarContainer {
                    width: 25%;
                }

                .nameContainer {
                    width: 45%;
                    font-weight: 600;

                    .longName {
                        width: 100px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }

            .dm-message-btn {
                font-size: 20px;
                margin-right: 35px;
                cursor: pointer;
            }
        }

        .user-info-head {
            font-weight: 600;
            font-size: medium;
        }

        .agent-item-detail {
            margin-left: 10px;
            margin-top: 5px;
            display: flex;
            align-items: center;

            #poped-icons {
                color: #e7957f;
                font-size: 15px;
                max-width: 22px;
                margin-right: 5px;
            }
        }

        .user-info-item {
            display: flex;
            margin-top: 20px;
            align-items: center;

            .user-info-content {
                padding-left: 5px;
            }
        }

        .poped_datas {
            width: 150px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    &::-webkit-scrollbar {
        display: none !important;
    }
}

.imgUpload {
    cursor: pointer;
    position: relative;
    width: 84px;
    height: 84px;

    &:hover {
        .imgUploadOver {
            opacity: 1;
        }
    }

    .imgUploadOver {
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        background-color: rgba(0, 0, 0, 0.55);
        color: #ffffff;
        font-size: 32px;
        opacity: 0;
        transition: all 0.3s ease-in-out;
        cursor: pointer;
        border-radius: 100%;
        text-align: center;
        line-height: 64px;
        display: grid;
        place-items: center;
    }
}

#team-summery-avatar {
    display: grid;
    place-items: center;
}

#groupViewerModal {
    .ant-modal {
        width: 52vw !important;
    }

    .ant-modal-close {
        .ant-modal-close-x {
            color: white;
            /*background: #434343;*/
            /*border-radius: 50%;*/
            position: absolute;
        }
    }

    .ant-modal-content {
        border-radius: 4px;
    }

    .ant-modal-body {
        padding: 0 !important;
    }

    img {
        width: 100%;
        height: 100%;
    }

    .ant-modal-mask {
        background-color: rgba(0, 0, 0, 0.75);
    }
}

#dropdown-menu {
    background-color: #ffffff;

    a,
    label,
    input {
        color: #161616;
    }

    .menu-item {
        .change-pp-class {
            display: none;
        }

        &:hover {
            background-color: #2196f3;

            a,
            label {
                color: #ffffff;
            }
        }
    }

    #delete-option {
        color: #161616;

        &:hover {
            background-color: #f44336;
            color: #ffffff;
        }
    }
}

.team-agents-avatar {
    position: relative;
    width: 30px;
    height: 30px;
    font-size: 14px !important;

    #avatar-img {
        border-radius: 50%;
        height: 30px !important;
        width: 30px !important;
        object-fit: cover;
    }

    #avatar-placeholder {
        border-radius: 50%;
        height: 30px !important;
        width: 30px !important;
        object-fit: cover;
        display: grid;
        place-items: center;

        span {
            font-size: 14px !important;
        }
    }

    #offline-dot {
        position: absolute;
        height: 25% !important;
        width: 25% !important;
        border-radius: 50%;
        background-color: #aeaeae;
        border: 0.5px solid white;
    }

    #online-dot {
        position: absolute;
        height: 25% !important;
        width: 25% !important;
        border-radius: 50%;
        background-color: #009900;
        border: 0.5px solid white;
    }
}

.team-chat-media-area {
    width: 95% !important;
}
</style>

<style lang="scss" scoped>
#team-chat-container {
    width: 85px;
    height: 85px;
    background-color: #d3d3d3;
    border-radius: 50%;
    display: grid;
    place-items: center;
}

#online-users-label {
    font-size: 14px;
    font-weight: bold;
    color: #18752c;
}

#offline-users-label {
    font-size: 14px;
    font-weight: bold;
    color: #545454;
}

.user-list {
    margin-top: 15px !important;
}
</style>
